import { createFeatureSelector, createSelector } from '@ngrx/store';

import { SignalRState } from './messages.model';
import { inRoomSignalRFeatureKey } from './messages.reducer';

export const selectMessageState = createFeatureSelector<SignalRState>(inRoomSignalRFeatureKey);

export const lastAlarm = createSelector(selectMessageState, (state: SignalRState) => state.alarmEvent);

export const lastBlind = createSelector(selectMessageState, (state: SignalRState) => state.blindsEvent);

export const lastButtonPress = createSelector(selectMessageState, (state: SignalRState) => state.buttonPressEvent);

export const lastCurtain = createSelector(selectMessageState, (state: SignalRState) => state.curtainEvent);

export const lastFanSpeed = createSelector(selectMessageState, (state: SignalRState) => state.fanSpeedEvent);

export const lastLight = createSelector(selectMessageState, (state: SignalRState) => state.ligthEvent);

export const lastMediaState = createSelector(selectMessageState, (state: SignalRState) => state.mediaStateEvent);

export const lastTemperature = createSelector(selectMessageState, (state: SignalRState) => state.temperatureEvent);

export const lastMood = createSelector(selectMessageState, (state: SignalRState) => state.moodStartedEvent);

export const lastRoomState = createSelector(selectMessageState, (state: SignalRState) => state.roomStateEvent);

export const lastAttributesState = createSelector(selectMessageState, (state: SignalRState) => state.attributesEvent);
